export const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const ROLLING_WINDOW_DAYS = 10;

function startOfToday() {
  var now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

// "YYYY-MM-DD" (local) — used as the doc key for a specific occurrence's poll/session,
// so each date instance gets its own votes/session that naturally fall out of the
// rolling window once the date has passed. No cron job needed.
export function dateKey(date) {
  var y = date.getFullYear();
  var m = String(date.getMonth() + 1).padStart(2, "0");
  var d = String(date.getDate()).padStart(2, "0");
  return y + "-" + m + "-" + d;
}

export function todayKey() {
  return dateKey(startOfToday());
}

// Every occurrence of a weekly dayOfWeek/time that falls within the next
// `daysAhead` days (today included, so daysAhead=10 covers today..+9).
// A weekly slot near the start of the window can occur twice (today's and next
// week's); one further out only occurs once.
export function occurrencesWithinDays(dayOfWeek, time, daysAhead) {
  var today = startOfToday();
  var todayDow = today.getDay();
  var firstOffset = (dayOfWeek - todayDow + 7) % 7;
  var parts = (time || "19:00").split(":");
  var hours = parseInt(parts[0], 10) || 0;
  var minutes = parseInt(parts[1], 10) || 0;

  var occurrences = [];
  for (var offset = firstOffset; offset < daysAhead; offset += 7) {
    var d = new Date(today);
    d.setDate(today.getDate() + offset);
    d.setHours(hours, minutes, 0, 0);
    occurrences.push(d);
  }
  return occurrences;
}

export function isToday(date) {
  return dateKey(date) === todayKey();
}

export function formatTime(time) {
  var parts = (time || "19:00").split(":");
  var h = parseInt(parts[0], 10) || 0;
  var m = parts[1] || "00";
  var suffix = h >= 12 ? "pm" : "am";
  var h12 = h % 12 === 0 ? 12 : h % 12;
  return m === "00" ? h12 + suffix : h12 + ":" + m + suffix;
}

export function formatDayTime(dayOfWeek, time, endTime) {
  var timeStr = endTime ? formatTime(time) + " – " + formatTime(endTime) : formatTime(time);
  return DAY_NAMES[dayOfWeek] + " " + timeStr;
}

export function formatDate(date) {
  return date.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
}
